module.exports = __webpack_public_path__ + "static/media/waves_green.aa8779c7.PNG";